import React from 'react';
import { useParams } from 'react-router-dom';

import { ViewEntityHeader } from 'components/entityViewer/ViewEntityHeader';
import { ViewEntityPage } from 'components/entityViewer/ViewEntityPage';
import { FC_TRANSFER_DIRECTION } from 'components/warehouse/components/fcTransfers/FCTransferFilterConfig';
import { useFCTransfersBackHref } from 'components/warehouse/components/fcTransfers/useFCTransfersBackHref';
import { Alert, AlertDescription, AlertTitle } from 'shadcn/components/ui/Alert';
import { Card, CardContent, CardHeader, CardTitle } from 'shadcn/components/ui/Card';

const FC_TRANSFERS_INBOUND_LIST_HREF = `/warehouse/fc-transfers?direction=${FC_TRANSFER_DIRECTION.INBOUND}`;

/**
 * Dedicated Accept Transfer page shell (tech spec §3.2, §6.1). Inbound receive UX will be built here later.
 */
export function ViewAcceptTransfer() {
    const { transferId } = useParams();
    const backHref = useFCTransfersBackHref({
        emptyFallback: FC_TRANSFERS_INBOUND_LIST_HREF,
    });

    const titleLabel =
        transferId === undefined || transferId === null || transferId === ''
            ? 'Accept Transfer'
            : `Accept Transfer #${transferId}`;

    return (
        <div className="flex min-h-screen flex-col px-4 pb-8 pt-4">
            <ViewEntityPage
                header={
                    <ViewEntityHeader backHref={backHref} backLabel="Back to FC Transfers" entityIdLabel={titleLabel} />
                }
                primaryInformationCard={
                    <Card>
                        <CardHeader>
                            <CardTitle className="text-base">Placeholder</CardTitle>
                        </CardHeader>
                        <CardContent>
                            <Alert>
                                <AlertTitle>Accept flow coming soon</AlertTitle>
                                <AlertDescription className="text-sm">
                                    This page is reserved for the inbound accept/receive workflow. It is separate from
                                    the standard transfer detail view.
                                </AlertDescription>
                            </Alert>
                        </CardContent>
                    </Card>
                }
            />
        </div>
    );
}

ViewAcceptTransfer.displayName = 'ViewAcceptTransfer';
